const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://lead-mgnt-2.onrender.com/api';

class DropdownOptionsService {
  static async getAuthHeaders() {
    const companyToken = localStorage.getItem('companyToken');
    const branchToken = localStorage.getItem('branchToken');
    const employeeToken = localStorage.getItem('employeeToken');
    const userToken = localStorage.getItem('userToken');
    
    const token = companyToken || branchToken || employeeToken || userToken;
    
    return {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` })
    };
  }

  // Get all dropdown options grouped by category
  static async getAllOptions() {
    try {
      const headers = await this.getAuthHeaders();
      const response = await fetch(`${API_BASE_URL}/dropdown-options`, {
        method: 'GET',
        headers
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return { success: true, data };
    } catch (error) {
      console.error('Error fetching dropdown options:', error);
      return { success: false, error: error.message };
    }
  }

  // Get options for specific category
  static async getOptionsByCategory(category) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await fetch(`${API_BASE_URL}/dropdown-options/${category}`, {
        method: 'GET',
        headers
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return { success: true, data };
    } catch (error) {
      console.error('Error fetching category options:', error);
      return { success: false, error: error.message };
    }
  }

  // Create new dropdown option
  static async createOption(optionData) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await fetch(`${API_BASE_URL}/dropdown-options`, {
        method: 'POST',
        headers,
        body: JSON.stringify(optionData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return { success: true, data };
    } catch (error) {
      console.error('Error creating dropdown option:', error);
      return { success: false, error: error.message };
    }
  }

  // Update dropdown option
  static async updateOption(id, optionData) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await fetch(`${API_BASE_URL}/dropdown-options/${id}`, {
        method: 'PUT',
        headers,
        body: JSON.stringify(optionData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return { success: true, data };
    } catch (error) {
      console.error('Error updating dropdown option:', error);
      return { success: false, error: error.message };
    }
  }

  // Delete dropdown option
  static async deleteOption(id) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await fetch(`${API_BASE_URL}/dropdown-options/${id}`, {
        method: 'DELETE',
        headers
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return { success: true, data };
    } catch (error) {
      console.error('Error deleting dropdown option:', error);
      return { success: false, error: error.message };
    }
  }

  // Update sort order for multiple options
  static async updateSortOrder(options) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await fetch(`${API_BASE_URL}/dropdown-options/bulk/sort-order`, {
        method: 'PUT',
        headers,
        body: JSON.stringify({ options })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return { success: true, data };
    } catch (error) {
      console.error('Error updating sort order:', error);
      return { success: false, error: error.message };
    }
  }

  // Initialize default options
  static async initializeDefaultOptions() {
    try {
      const headers = await this.getAuthHeaders();
      const response = await fetch(`${API_BASE_URL}/dropdown-options/initialize`, {
        method: 'POST',
        headers
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return { success: true, data };
    } catch (error) {
      console.error('Error initializing default options:', error);
      return { success: false, error: error.message };
    }
  }
}

export default DropdownOptionsService;
